export const breakpoints = {
  values: {
    phone: 500,
    tablet: 768,
    laptop: 1000,
    desktop: 1200,
  },
};
